import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import type { RoomResponse } from 'app/typings/core/admin/rooms/room';
import type { UpdateBuilderRoomRequest } from 'app/typings/core/builder/roomForm';
import { apiMutation } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '.';

type UpdateBuilderRoomParams = {
  roomId: number;
  payload: UpdateBuilderRoomRequest;
};

export function useUpdateBuilderRoom(hotelId: number) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ roomId, payload }: UpdateBuilderRoomParams) =>
      apiMutation(
        'PATCH',
        {
          path: ENDPOINTS.updateRoom,
          params: { id: hotelId.toString(), roomId: roomId.toString() },
        },
        payload
      ) as Promise<RoomResponse>,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [CORE_QUERY_KEYS.builderRooms, { id: hotelId }],
      });
      message.success('Room successfully updated');
    },
    onError: () => {
      message.error('Failed to update room');
    },
  });
}
